/* Shortens the Bundler tier labels for the card layout: "Buy 2 and get a discount!" becomes "Buy 2".
   Idempotent, and it re-runs if the Bundler widget is re-rendered. */
(function () {
  var queued = false;
  function tidy() {
    queued = false;
    document.querySelectorAll('.bndlr-quantity-break .bndlr-text').forEach(function (el) {
      var match = el.textContent.trim().match(/^Buy\s+(\d+)\b/i);
      if (match && el.textContent.trim() !== 'Buy ' + match[1]) el.textContent = 'Buy ' + match[1];
    });
  }
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(tidy);
  }
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
  queue();
})();
